import View from "./view.js";
import previewView from "./previewView.js";
import icons from 'url:../../img/icons.svg';

class BookmarksView extends View{
    _parentElement = document.querySelector('.bookmarks__list');
    _errorMessage = 'No bookmarks yet. Find a recipe and bookmark it.';
    _message = ''

    _generateMarkup()
    {
        return this._data.map(result=>previewView.render(result , false)).join();
    }


    addHandlerRenderBokkmarks(handler)
    {
        window.addEventListener('load', function(){
            handler();
        })
    }
}

export default new BookmarksView();